// [INC-20260220-1515] Dead imports removed: WizardContainer, CanvasRenderer
// These legacy package components are no longer referenced by any Firestore region config.
import { HeroIsland } from '@emoji-photo/islands';
import TL_HeaderIsland from '../components/thelook/TL_HeaderIsland.vue';
import TL_UploadIsland from '../components/thelook/TL_UploadIsland.vue';
import TL_EmojiIsland from '../components/thelook/TL_EmojiIsland.vue';
import TL_PreviewIsland from '../components/thelook/TL_PreviewIsland.vue';
import TL_CollageIsland from '../components/thelook/TL_CollageIsland.vue';
import TL_CustomizerIsland from '../components/thelook/TL_CustomizerIsland.vue';
import DummyIsland from '../components/DummyIsland.vue';

// Map String IDs to Actual Components
export const IslandRegistry = {
    'HeaderIsland': TL_HeaderIsland,
    'HeroIsland': HeroIsland,
    // 'AuthIsland': AuthIsland,
    'UploadIsland': TL_UploadIsland,
    'EmojiIsland': TL_EmojiIsland,
    'PreviewIsland': TL_PreviewIsland,
    'CollageIsland': TL_CollageIsland,
    'CustomizerIsland': TL_CustomizerIsland,
    'DummyIsland': DummyIsland
};

// Metadata for Admin Builder (Prop Schema + Stylable Props)
export const IslandManifest = {
    'HeroIsland': {
        label: "Hero Section",
        props: [
            { name: 'title', type: 'string', default: 'Welcome' },
            { name: 'subtitle', type: 'string', default: 'Start your journey' }
        ],
        stylableProps: ['backgroundColor', 'padding', 'textAlign', 'borderRadius']
    },
    'UploadIsland': {
        label: "Upload Photo",
        props: [],
        stylableProps: ['borderStyle', 'shadow', 'padding']
    },
    'EmojiIsland': {
        label: "Emoji Picker",
        props: [],
        stylableProps: ['gap', 'itemRadius']
    },
    'PreviewIsland': {
        label: "AI Preview",
        props: [],
        stylableProps: ['borderRadius', 'shadow']
    },
    'CollageIsland': {
        label: "Collage Canvas",
        props: [],
        stylableProps: ['borderStyle']
    },
    'CustomizerIsland': {
        label: "Download Controls",
        props: [
            { name: 'title', type: 'string', default: 'Customize & Download' }
        ],
        stylableProps: ['padding', 'gap']
    },
    // 'AuthIsland': { label: "Login Form", props: [], stylableProps: ['borderRadius', 'shadow'] },
    'DummyIsland': {
        label: "Crash Test Dummy",
        props: [],
        stylableProps: []
    }
};
